export default __webpack_public_path__ + "static/media/banner-site-expressojk-mobile-2.2d53cc6a.png";